/*
  eslint
  no-param-reassign: ["error", { "props": false }]
  no-console: "off"
*/
import Vue from 'vue';
import LIST_ORGANIZATIONS from './queries/listOrganizations.gql';
import GET_ORGANIZATION from './queries/getOrganization.gql';
import CREATE_ORGANIZATION from './mutations/createOrganization.gql';
import LIST_ANALYTICS from './queries/listAnalytics.gql';
import GET_ANALYTIC from './queries/getAnalytic.gql';
import UPDATE_ANALYTIC from './mutations/updateAnalytic.gql';
import CREATE_ANALYTIC from './mutations/createAnalytic.gql';
import DELETE_ANALYTIC from './mutations/deleteAnalytic.gql';
import GET_RELEASE from './queries/getRelease.gql';
import LIST_RELEASES from './queries/listReleases.gql';
import CREATE_RELEASE from './mutations/createRelease.gql';
import LIST_BUILDS from './queries/listBuilds.gql';
import UPDATE_RELEASE from './mutations/updateRelease.gql';
import UPDATE_RELEASE_ORGANIZATION_STATUS from './mutations/updateReleaseOrganizationStatus.gql';
import GET_TOKEN from './queries/getToken.gql';

const AdminStoreModule = {
  namespaced: true,
  state: {
    analytic: null,
    release: null,
  },
  getters: { },
  mutations: {
    SET_ANALYTIC(state, payload) {
      state.analytic = payload;
    },
    SET_RELEASE(state, payload) {
      state.release = payload;
    },
  },
  actions: {
    async listBuilds({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: LIST_BUILDS,
        variables: {},
        key: 'listBuilds',
      }, { root: true });
      return result;
    },
    async createRelease({ dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: CREATE_RELEASE,
        variables: payload,
        key: 'createRelease',
      }, { root: true });
      return result;
    },
    async listReleases({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: LIST_RELEASES,
        variables: {},
        key: 'listReleases',
      }, { root: true });
      return result;
    },
    async getRelease({ commit, dispatch }, payload) {
      commit('SET_RELEASE', null);
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: GET_RELEASE,
        variables: payload,
        key: 'getRelease',
      }, { root: true });
      commit('SET_RELEASE', result);
      return result;
    },
    async getToken({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: GET_TOKEN,
        variables: payload,
        key: 'getToken',
      }, { root: true });
      return result;
    },
    async listOrganizations({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: LIST_ORGANIZATIONS,
        variables: {},
        key: 'listOrganizations',
      }, { root: true });
      return result;
    },
    async getOrganization({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: GET_ORGANIZATION,
        variables: payload,
        key: 'getOrganization',
      }, { root: true });
      return result;
    },
    async createOrganization({ dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: CREATE_ORGANIZATION,
        variables: payload,
        key: 'createOrganization',
      }, { root: true });
      return result;
    },
    async listAnalytics({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: LIST_ANALYTICS,
        variables: {},
        key: 'listAnalytics',
      }, { root: true });
      return result;
    },
    async getAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.admin,
        query: GET_ANALYTIC,
        variables: payload,
        key: 'getAnalytic',
      }, { root: true });
      commit('SET_ANALYTIC', result);
      return result;
    },
    async createAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: CREATE_ANALYTIC,
        variables: payload,
        key: 'createAnalytic',
      }, { root: true });
      commit('SET_ANALYTIC', result);
      return result;
    },
    async updateAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: UPDATE_ANALYTIC,
        variables: payload,
        key: 'updateAnalytic',
      }, { root: true });
      commit('SET_ANALYTIC', result);
      return result;
    },
    async deleteAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: DELETE_ANALYTIC,
        variables: payload,
        key: 'deleteAnalytic',
      }, { root: true });
      commit('SET_ANALYTIC', result);
      return result;
    },
    async updateRelease({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: UPDATE_RELEASE,
        variables: payload,
        key: 'updateRelease',
      }, { root: true });
      commit('SET_RELEASE', result);
      return result;
    },
    async updateReleaseOrganizationStatus({ dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.admin,
        query: UPDATE_RELEASE_ORGANIZATION_STATUS,
        variables: payload,
        key: 'updateReleaseOrganizationStatus',
      }, { root: true });
      return result;
    },
  },
};

export default AdminStoreModule;
